exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*@media all and (max-width: 1024px) {\r\n  .ft__logo {\r\n    margin-top: 20%;\r\n    background:red;\r\n    max-width: 65%;\r\n  }\r\n}*/\r\n\r\n.subscribe__btn input:hover {\r\n  cursor:pointer;\r\n}\r\n\r\n.left_0{\r\n  left: 0 !important;\r\n}\r\n\r\n.htc__foooter__area{\r\n  margin-top:0;\r\n  /* margin-top:144px !important; */\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/majli/reposales365/sale365/src/app/footer/footer.component.css
// module id = ../../../../../src/app/footer/footer.component.css
// module chunks = main